module.exports = __webpack_public_path__ + "img/floorplan-icon.a691bc65.svg";